import dynamic from "next/dynamic";

import {
  BffComponentType as Component,
  ComponentsConfig,
} from "~/bff/ComponentsConfig";
import { StoreDetailsPage } from "~/components/store-details-page/component";
import { importComponentByName } from "~/helpers/import-component-by-name";

const GenericTextImageBanner = dynamic(async () =>
  importComponentByName(
    import("~/components/generic-text-image-banner/component"),
    "GenericTextImageBanner",
  ),
);

export const storeDetailsPageConfig: ComponentsConfig = {
  [Component.STORE_DETAILS_PAGE]: {
    component: StoreDetailsPage,
  },
  [Component.GENERIC_BANNER]: {
    component: GenericTextImageBanner,
  },
};
